import { type FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { Logo } from './logos/logo-kh';

interface SplashScreenProps {
  layer: string;
  variant?: 'error' | 'maintenance' | 'loading';
  error?: boolean;
}

// TODO: provide more scenarios (error, maintenance, etc.)
export const SplashScreen: FC<SplashScreenProps> = ({
  layer,
  variant,
  error
}) => {
  // variant shorthands
  if (variant === undefined && error) variant = 'error';
  else if (variant === undefined) variant = 'loading';

  // improve debugging splash screen problems
  useEffect(
    () => console.log(`Splash screen (${variant}) in layer ${layer}`),
    [layer, variant]
  );

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        justifyContent: 'center',
        left: 0,
        p: 3,
        position: 'fixed',
        top: 0,
        width: '100vw',
        zIndex: 1400
      }}
    >
      <Box
        width={64}
        height={64}
        display="flex"
        overflow="hidden"
      >
        <Logo />
      </Box>
    </Box>
  );
};
